module.exports = require("url");


//////////////////
// WEBPACK FOOTER
// external "url"
// module id = 6
// module chunks = 0